import { Column} from 'react-table'
import { ApplicationStateCell, ShowDateCell } from '../../../../../../components/widgets';
import { ApplicationReviewApplicantActionsCell } from '../../../../../company/applications/submit-response-modal/components/ApplicationReviewApplicantActionsCell';
import { ApplicationReview } from '../../../_models';
import { ApplicationReviewNotesCell, ApplicationReviewNotesHeader } from '../components';
import { PropsWithNotes } from '../../../../../../components/table';


export const ApplicationReviewApplicantColumns: ReadonlyArray<Column<PropsWithNotes<ApplicationReview>>> = [
  {    
    Header: 'Type',
    minWidth: 80,
    accessor: 'type',
  },
  {    
    Header: 'Actions',
    minWidth: 125,
    accessor: 'type',
    id: 'actions',
    Cell: ({...props}) => <ApplicationReviewApplicantActionsCell review={props.data[props.row.index]} />,
  },
  {  
    Header: <ApplicationReviewNotesHeader />,
    minWidth: 20,  
    id: 'notes',
    Cell: ({...props}) => <ApplicationReviewNotesCell row={props.data[props.row.index]} />,
  },    
  {
    Header: 'State',
    minWidth: 225,    
    id: 'state',
    Cell: ({...props}) => 
    <div className="d-flex flex-row align-items-center gap-1">            
        <ApplicationStateCell state_val={props.data[props.row.index].state} className="min-w-225px" />            
    </div>
  },  
  {
    Header: 'Last Update',
    minWidth: 125,        
    id: 'dteUpd',
    Cell: ({...props}) => <ShowDateCell date_val={props.data[props.row.index].dteUpd} />,
  },
];

